import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';
import { fetchNavigation } from '~/api/services/navigation.service';
import { useAuthStore } from '~/store/auth.store';

const ONE_MINUTE = 60 * 1000;

/**
 * Fetches the navigation menu from GET /screens/navigation.
 * Query key includes tenantId, userId, and isImpersonating to auto-bust
 * the cache on tenant switch, impersonation start/stop, and user change.
 */
export function useNavigation() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const tenantId = useAuthStore((s) => s.user?.activeTenantId ?? '');
  const userId = useAuthStore((s) => s.user?.id ?? '');
  const isImpersonating = useAuthStore((s) => s.isImpersonating);

  return useQuery({
    queryKey: queryKeys.navigation.menu(tenantId, userId, isImpersonating),
    queryFn: fetchNavigation,
    enabled: isAuthenticated && !!tenantId,
    staleTime: ONE_MINUTE,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 1,
  });
}
